import React, { useContext } from 'react';

import { Trans } from '@lingui/macro';

import PageContext from '@zego/context/PageContext';
import { disabledColor, white } from '@zego/theme';
import { useTracking } from '@zego/tracking';

import Button from '@zego/components/button/ButtonLink';
import { getGooglePlayLinkFromLanguage } from '@zego/components/GooglePlayLink';

const IconGooglePlay = ({ fill }) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6,23.928 L6,24 L14.5,19 L17.5956547,17.185 L15.1323291,14.705 L6,23.928 Z M18.4515643,11.334 L15.8020857,14 L18.4515643,16.667 L23,14 L18.4515643,11.334 Z M17.5670915,10.816 L14.5,9 L6,4 L6,4.072 L15.1323291,13.296 L17.5670915,10.816 Z M14.469467,13.967 L6,22.517 L6,14 L6,5.423 L14.469467,13.967 Z"
      id="google_play-[#133]"
      fill={fill}
    />
  </svg>
);

const GooglePlayButton = ({ darkTheme = false, link, fullWidth = false }) => {
  const { trackEvent } = useTracking();
  const { language } = useContext(PageContext);

  const googlePlayLink = link || getGooglePlayLinkFromLanguage(language);

  return (
    <Button
      css={
        ({
          boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
        },
        [fullWidth ? { flex: '0 0 100%' } : null])
      }
      backgroundColor={darkTheme === true ? disabledColor(10) : white}
      icon={
        <IconGooglePlay
          fill={darkTheme === true ? white : disabledColor(10)}
        />
      }
      href={googlePlayLink}
      onClick={event => {
        event.preventDefault();
        trackEvent('Google Play Button Click');
        if (typeof window !== 'undefined') {
          window.open(googlePlayLink, '_blank');
        }
      }}
      title="Get the Zego app on the Google Play Store"
    >
      <Trans id="Google Play Button / Get it for Android">
        Get it for Android
      </Trans>
    </Button>
  );
};

export default GooglePlayButton;
